import React from 'react';
import { Link } from 'react-router-dom';
import './index.css';

const ModernAbout = ({ config }) => {
    const { about } = config;
    const paragraphs = about.paragraphs || [];

    return (
        <section id="about" className="modern-about">
            <div className="container">
                <div className="modern-about__grid">
                    <div className="modern-about__visual">
                        <div className="modern-about__img-wrap">
                            <img
                                className="modern-about__img"
                                src={about.image}
                                alt={about.heading}
                            />
                        </div>
                        {about.insetImage && (
                            <div className="modern-about__inset-wrap">
                                <img
                                    className="modern-about__inset"
                                    src={about.insetImage}
                                    alt="About detail"
                                />
                            </div>
                        )}
                    </div>

                    <div className="modern-about__content-wrapper">
                        <div className="modern-about__content">
                            {about.sub_heading && (
                                <div className="modern-about__kicker-wrap">
                                    <span className="modern-about__kicker-line"></span>
                                    <span className="modern-about__kicker">{about.sub_heading}</span>
                                </div>
                            )}
                            <h2 className="modern-about__title">{about.heading}</h2>
                            <div className="modern-about__text">
                                {paragraphs.map((paragraph, index) => (
                                    <p key={index}>{paragraph}</p>
                                ))}
                            </div>
                            <Link to="/restaurants" className="modern-about__btn">
                                Discover Menu
                                <i className="fa fa-long-arrow-right" style={{ marginLeft: 8 }} />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const ClassicAbout = ({ config }) => {
    const { about } = config;
    const paragraphs = about.paragraphs || [];

    return (
        <section id="about" className="classic-story">
            <div className="container">
                <div className="classic-story__layout">
                    {/* LEFT: Dual Image Mosaic */}
                    <div className="classic-story__gallery">
                        <div className="classic-story__img-primary">
                            <img
                                src={about.image}
                                alt={about.heading}
                            />
                        </div>
                        {about.insetImage && (
                            <div className="classic-story__img-secondary">
                                <img
                                    src={about.insetImage}
                                    alt="Our heritage"
                                />
                            </div>
                        )}
                        <div className="classic-story__accent-line" />
                    </div>

                    {/* RIGHT: Text Content */}
                    <div className="classic-story__content">
                        <div className="classic-story__tag">
                            <span className="classic-story__tag-dot" />
                            <span className="classic-story__tag-text">{about.sub_heading}</span>
                        </div>
                        <h2 className="classic-story__title">{about.heading}</h2>
                        <div className="classic-story__divider">
                            <span className="classic-story__divider-bar" />
                        </div>
                        <div className="classic-story__text">
                            {paragraphs.map((paragraph, index) => (
                                <p key={index}>{paragraph}</p>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const ApparelAbout = ({ config }) => {
    const { about } = config;
    const paragraphs = about.paragraphs || [];

    return (
        <div id="brand-about" className="apparel-about-section">
            <div className="container" style={{ maxWidth: '1400px' }}>
                <div className="apparel-about-grid">
                    {/* Left Column: Big elegant text */}
                    <div className="apparel-about-text-col">
                        <div className="apparel-about-header">
                            <span className="apparel-about-kicker">{about.sub_heading}</span>
                            <h2 className="apparel-about-title">{about.heading}</h2>
                        </div>
                        <div className="apparel-about-content">
                            {paragraphs.map((paragraph, index) => (
                                <p key={index}>{paragraph}</p>
                            ))}
                        </div>
                    </div>

                    {/* Right Column: Layered Images */}
                    <div className="apparel-about-img-col">
                        <div className="apparel-about-img-wrapper">
                            <img
                                className="apparel-main-img"
                                src={about.image}
                                alt={about.heading}
                            />
                            {about.insetImage && (
                                <div className="apparel-inset-img">
                                    <img src={about.insetImage} alt="Apparel Inset" />
                                </div>
                            )}
                            <div className="apparel-about-decorative-box"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const LuxuryAbout = ({ config }) => {
    const { about } = config;
    const paragraphs = about.paragraphs || [];

    return (
        <div id="about" className="luxury-about pad-top-100 pad-bottom-100">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="luxury-about__images">
                            <div className="luxury-about__img-main">
                                <img src={about.image} alt={about.heading} />
                            </div>
                            <div className="luxury-about__img-stacked">
                                <div className="luxury-about__img-item">
                                    <img src={about.insetImage || about.image} alt="About Inset" />
                                </div>
                                <div className="luxury-about__img-item">
                                    <img src={about.image} alt="About Decorative" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="luxury-about__content">
                            <div className="luxury-about__header">
                                <span className="luxury-about__kicker">{about.sub_heading}</span>
                                <h2 className="luxury-about__title">{about.heading}</h2>
                            </div>
                            <div className="luxury-about__text">
                                {paragraphs.map((p, idx) => <p key={idx}>{p}</p>)}
                            </div>
                            <a href="#categories" className="luxury-about__btn">Explore More</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const SweetShopAbout = ({ config }) => {
    const { about } = config;
    const paragraphs = about.paragraphs || [];

    return (
        <div id="about" className="sweet-shop-about">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <div className="sweet-shop-about__visual">


                            <div className="sweet-shop-about__img-main-box">
                                <img
                                    src={about.image}
                                    alt={about.heading}
                                    className="sweet-shop-about__main-img"
                                />

                                {about.insetImage && (
                                    <div className="sweet-shop-about__img-sub-box">
                                        <div className="sweet-shop-about__sub-rim" />
                                        <img
                                            src={about.insetImage}
                                            alt="Sweet Inset"
                                            className="sweet-shop-about__sub-img"
                                        />
                                    </div>
                                )}
                            </div>

                            {/* Magic candy sparkles */}
                            <div className="sweet-shop-about__sparkle sweet-shop-about__sparkle--1">✦</div>
                            <div className="sweet-shop-about__sparkle sweet-shop-about__sparkle--2">✦</div>
                            <div className="sweet-shop-about__sparkle sweet-shop-about__sparkle--3">✦</div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="sweet-shop-about__content">
                            <span className="sweet-shop-about__badge">{about.sub_heading}</span>
                            <h2 className="sweet-shop-about__title">{about.heading}</h2>
                            <div className="sweet-shop-about__text">
                                {paragraphs.map((paragraph, index) => (
                                    <p key={index}>{paragraph}</p>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const HeritageAbout = ({ config }) => {
    const { about } = config;
    const paragraphs = about.paragraphs || [];

    return (
        <div id="about" className="hr-about">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <div className="hr-about__visual">
                            <div className="hr-about__img-frame">
                                <div className="hr-about__gold-border" />
                                <img src={about.image} alt={about.heading} className="hr-about__main-img" />
                                {about.insetImage && (
                                    <div className="hr-about__year-badge">
                                        <img src={about.insetImage} alt="Inset" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="hr-about__content">
                            <div className="hr-about__ornament">
                                <span className="hr-ornament-line" />
                                <span className="hr-ornament-icon">✦</span>
                                <span className="hr-ornament-line" />
                            </div>
                            <span className="hr-about__kicker">{about.sub_heading}</span>
                            <h2 className="hr-about__title">{about.heading}</h2>
                            <div className="hr-about__text">
                                {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const ModernMithaiAbout = ({ config }) => {
    const { about } = config;
    const paragraphs = about.paragraphs || [];

    return (
        <div id="about" className="mm-about">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <div className="mm-about__visual">
                            <div className="mm-about__img-main">
                                <img src={about.image} alt={about.heading} />
                            </div>
                            {about.insetImage && (
                                <div className="mm-about__img-inset">
                                    <img src={about.insetImage} alt="Inset" />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="mm-about__content">
                            <span className="mm-about__kicker">{about.sub_heading}</span>
                            <h2 className="mm-about__title">{about.heading}</h2>
                            <div className="mm-about__text">
                                {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const FestiveSweetsAbout = ({ config }) => {
    const { about } = config;
    const paragraphs = about.paragraphs || [];

    return (
        <div id="about" className="fs-about">
            <div className="fs-about__deco-dots" />
            <div className="container">
                <div className="fs-about__grid">
                    <div className="fs-about__images">
                        <div className="fs-about__img-main-wrap">
                            <div className="fs-about__img-border" />
                            <img src={about.image} alt={about.heading} className="fs-about__img-main" />
                        </div>
                        {about.insetImage && (
                            <div className="fs-about__img-inset-wrap">
                                <img src={about.insetImage} alt="Inset" className="fs-about__img-inset" />
                            </div>
                        )}
                    </div>

                    <div className="fs-about__content">
                        <div className="fs-about__tag">
                            <span className="fs-about__tag-line" />
                            <span>{about.sub_heading}</span>
                            <span className="fs-about__tag-line" />
                        </div>
                        <h2 className="fs-about__title">{about.heading}</h2>
                        <div className="fs-about__text">
                            {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const RoyalConfectionsAbout = ({ config }) => {
    const { about } = config;
    const paragraphs = about.paragraphs || [];

    return (
        <div id="about" className="rc-about">
            <div className="container">
                <div className="rc-about__layout">
                    <div className="rc-about__visual">
                        <div className="rc-about__img-wrap">
                            <img src={about.image} alt={about.heading} className="rc-about__img" />
                            <div className="rc-about__img-frame" />
                            {about.insetImage && (
                                <div className="rc-about__inset-img">
                                    <img src={about.insetImage} alt="Royal Inset" />
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="rc-about__content">
                        <div className="rc-about__eyebrow">
                            <span className="rc-about__eyebrow-line" />
                            <span>{about.sub_heading}</span>
                        </div>
                        <h2 className="rc-about__title">{about.heading}</h2>
                        <blockquote className="rc-about__pullquote">
                            "{about.sub_heading}"
                        </blockquote>
                        <div className="rc-about__text">
                            {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const TraditionalAbout = ({ config }) => {
    const { about } = config;
    const paragraphs = about.paragraphs || [];

    return (
        <section id="about" className="trad-about pad-top-120 pad-bottom-120">
            <div className="container">
                <div className="trad-about__layout">
                    {/* Visual Side */}
                    <div className="trad-about__visual">
                        <div className="trad-about__frame">
                            <div className="trad-about__frame-border"></div>
                            <img src={about.image} alt={about.heading} className="trad-about__main-img" />
                        </div>
                        {about.insetImage && (
                            <div className="trad-about__inset">
                                <img src={about.insetImage} alt="Trad Inset" />
                            </div>
                        )}
                        <div className="trad-about__ornament" />
                    </div>

                    {/* Content Side */}
                    <div className="trad-about__content">
                        <div className="trad-about__header">
                            <span className="trad-about__kicker">{about.sub_heading}</span>
                            <h2 className="trad-about__title">{about.heading}</h2>
                            <div className="trad-about__divider"></div>
                        </div>

                        <div className="trad-about__text">
                            {paragraphs.map((p, i) => (
                                <p key={i} className={i === 0 ? 'trad-about__dropcap' : ''}>
                                    {p}
                                </p>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const SunburstAbout = ({ config }) => {
    const { about } = config;
    const paragraphs = about.paragraphs || [];

    return (
        <div id="about" className="ssb-about pad-top-100 pad-bottom-100">
            <div className="ssb-about__bg-glow" />
            <div className="container">
                <div className="ssb-about__layout">
                    <div className="ssb-about__visual">
                        <div className="ssb-about__img-wrapper">
                            <img src={about.image} alt={about.heading} />
                            {about.insetImage && (
                                <div className="ssb-about__inset">
                                    <img src={about.insetImage} alt="Sunburst Inset" />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="ssb-about__content">
                        <div className="ssb-about__tag">{about.sub_heading}</div>
                        <h2 className="ssb-about__title">{about.heading}</h2>
                        <div className="ssb-about__description">
                            {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const TraditionalSweetsAbout = ({ config }) => {
    const { about } = config;
    const paragraphs = about.paragraphs || [];

    return (
        <div id="about" className="ts-about">
            <div className="container">
                <div className="ts-about__card">
                    <div className="ts-about__row">
                        <div className="ts-about__img-side">
                            <div className="ts-about__img-frame">
                                <img src={about.image} alt={about.heading} className="ts-about__img" />
                                <div className="ts-about__stamp">{about.sub_heading}</div>
                                {about.insetImage && (
                                    <div className="ts-about__inset">
                                        <img src={about.insetImage} alt="Traditional Sweets Inset" />
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="ts-about__text-side">
                            <div className="ts-about__badge">{about.sub_heading}</div>
                            <h2 className="ts-about__title">{about.heading}</h2>
                            <div className="ts-about__content">
                                {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const LegacyAshaAbout = ({ config }) => {
    const { about } = config;
    const paragraphs = about.paragraphs || [];

    return (
        <div id="about" className="asha-about">
            <div className="container">
                <div className="row align-items-center">
                    {/* Left Column: Overlapping Collage Frames */}
                    <div className="col-lg-6">
                        <div className="asha-about__collage">
                            {/* Decorative background outline frame */}
                            <div className="asha-about__deco-frame" />

                            {/* Main Image in Arched Frame */}
                            <div className="asha-about__img-main">
                                <img src={about.image} alt={about.heading} className="asha-about__pic-main" />
                            </div>

                            {/* Inset Image Overlapping at Bottom Right */}
                            {about.insetImage && (
                                <div className="asha-about__img-sub">
                                    <div className="asha-about__sub-border" />
                                    <img src={about.insetImage} alt="Our Heritage Inset" className="asha-about__pic-sub" />
                                </div>
                            )}


                        </div>
                    </div>

                    {/* Right Column: Premium Text & Highlights */}
                    <div className="col-lg-6">
                        <div className="asha-about__content">
                            <div className="asha-about__tagline">
                                <span className="tagline-ornament">✧</span>
                                <span className="tagline-text">{about.sub_heading || 'sweetness'}</span>
                                <span className="tagline-ornament">✧</span>
                            </div>

                            <div className="asha-about__title-wrap">
                                <h2 className="asha-about__title">{about.heading || 'resturant'}</h2>

                                <div className="asha-about__divider">
                                    <span className="divider-line" />
                                    <span className="divider-star">✦</span>
                                    <span className="divider-line" />
                                </div>
                            </div>

                            <div className="asha-about__text">
                                {paragraphs.map((para, index) => (
                                    <p key={index} className="asha-about__para">{para}</p>
                                ))}
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const CafeAbout = ({ config }) => {
    const { about } = config;
    const paragraphs = about.paragraphs || [];

    return (
        <div id="about" className="cafe-about">
            <div className="container">
                <div className="cafe-about__layout">
                    <div className="cafe-about__visual">
                        <div className="cafe-about__img-wrap">
                            <img src={about.image} alt={about.heading} className="cafe-about__main-img" />
                        </div>
                        {about.insetImage && (
                            <div className="cafe-about__img-inset">
                                <img src={about.insetImage} alt="Inset" />
                            </div>
                        )}
                        <div className="cafe-about__deco-bean" />
                    </div>

                    <div className="cafe-about__content">
                        <div className="cafe-about__tag">
                            <span className="cafe-about__tag-line" />
                            <span>{about.sub_heading}</span>
                        </div>
                        <h2 className="cafe-about__title">{about.heading}</h2>
                        <div className="cafe-about__text">
                            {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// ============================================================================
// TEMPLATE 15 - DRY FRUITS
// ============================================================================
const DryFruitsAbout = ({ config }) => {
    const { about } = config;
    const paragraphs = about.paragraphs || [];

    return (
        <div id="about" className="df-about py-5">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5">
                        <div className="df-about__image">
                            <img src={about.image} alt={about.heading || 'About Us'} />
                        </div>
                    </div>
                    <div className="col-lg-7 pl-lg-5">
                        <div className="df-about__content">
                            <h2 className="df-about__title">{about.heading || 'ABOUT US'}</h2>
                            <h3 className="df-about__subtitle">{about.sub_heading}</h3>
                            <div className="df-about__divider"></div>

                            <div className="df-about__text">
                                {paragraphs.map((text, idx) => (
                                    <p key={idx}>{text}</p>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// ═══════════════════════════════════════════════════════════════════
// TEMPLATE 16 — ARISA COLLECTION — Brand Story
// Large image + editorial copy, thin gold rule motif, restrained CTA.
// ═══════════════════════════════════════════════════════════════════
const SweetStoreAbout = ({ config }) => {
    const { about } = config;
    const paragraphs = about?.paragraphs || [];

    return (
        <div id="about" className="t16-about">
            <div className="t16-about__container">
                <div className="t16-about__visual">
                    {about?.image && <img src={about.image} alt={about.heading || 'Our Story'} className="t16-about__img" />}
                </div>
                <div className="t16-about__content">
                    <span className="t16-about__kicker">About Us</span>
                    <h2 className="t16-about__title">{about?.heading || 'Made with Tradition. Shared with Love.'}</h2>
                    <div className="t16-about__body">
                        <span className="t16-about__rule" aria-hidden="true" />
                        <div className="t16-about__text">
                            {about?.sub_heading && (
                                <p className="t16-about__subheading">{about.sub_heading}</p>
                            )}
                            {paragraphs.length > 0 ? (
                                paragraphs.map((text, idx) => <p key={idx}>{text}</p>)
                            ) : (
                                <p>Every sweet we make carries a story — of family recipes, patient craft, and quality
                                    ingredients chosen with care.</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const AboutSection = (props) => {
    const type = (props.config.templateType || 'template1').toLowerCase().replace(/-/g, '_');

    switch (type) {
        case 'template1':
        case 'modern':
            return <ModernAbout {...props} />;
        case 'template2':
        case 'classic':
            return <ClassicAbout {...props} />;
        case 'template3':
        case 'traditional':
            return <TraditionalAbout {...props} />;
        case 'template4':
        case 'asha_legacy':
            return <LegacyAshaAbout {...props} />;
        case 'template5':
        case 'apparel':
            return <ApparelAbout {...props} />;
        case 'template6':
        case 'luxury_restaurant':
            return <LuxuryAbout {...props} />;
        case 'template7':
        case 'sweet_shop':
            return <SweetShopAbout {...props} />;
        case 'template8':
        case 'heritage_royal':
            return <HeritageAbout {...props} />;
        case 'template9':
        case 'modern_mithai':
            return <ModernMithaiAbout {...props} />;
        case 'template10':
        case 'festive_sweets':
            return <FestiveSweetsAbout {...props} />;
        case 'template11':
        case 'royal_confections':
            return <RoyalConfectionsAbout {...props} />;
        case 'template12':
        case 'traditional_sweets':
            return <TraditionalSweetsAbout {...props} />;
        case 'template13':
        case 'sunburst_gourmet':
            return <SunburstAbout {...props} />;
        case 'template14':
        case 'cafe_premium':
            return <CafeAbout {...props} />;
        case 'template15':
        case 'dry_fruits':
            return <DryFruitsAbout {...props} />;
        case 'template16':
        case 'arisa_collection':
            return <SweetStoreAbout {...props} />;
        default:
            return <ModernAbout {...props} />;
    }
};

export const FounderSection = () => null;

export default AboutSection;
